import script from "./xinhuodonggydjt.vue?vue&type=script&setup=true&lang=js"
export * from "./xinhuodonggydjt.vue?vue&type=script&setup=true&lang=js"

import "./xinhuodonggydjt.vue?vue&type=style&index=0&id=79a92ced&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a92ced"]])

export default __exports__